import { generateClient } from "aws-amplify/api";
import { fetchAuthSession } from "aws-amplify/auth";

const client = generateClient();

/**
 * Executes AppSync GraphQL using Cognito User Pools auth.
 * Forces ID token so @auth owner rules using identityClaim:"email" work reliably.
 */
export async function graphqlUserPool<TData>(args: {
    query: any;
    variables?: Record<string, any>;
    authToken?: string;
}): Promise<TData> {
    const idToken = args.authToken ?? (await fetchAuthSession()).tokens?.idToken?.toString();

    if (!idToken) {
        throw new Error("Missing ID token (user may not be authenticated).");
    }

    const resp: any = await client.graphql({
        query: args.query,
        variables: args.variables,
        authMode: "userPool",
        authToken: idToken,
    });

    if (resp?.errors?.length) {
        const msg = resp.errors.map((e: any) => e?.message ?? String(e)).join(" | ");
        throw new Error(msg);
    }

    return resp.data as TData;
}
